import { jsx as o } from "react/jsx-runtime";
import { memo as s, useMemo as l } from "react";
import { Row as n, Col as i } from "antd";
import f from "./SimpleSelect.js";
const p = ({ value: e, defaultOption: r, span: t = 14, ...m }) => {
  const c = l(() => !e && r ? r : e, [r, e]);
  return /* @__PURE__ */ o(n, { children: /* @__PURE__ */ o(i, { span: t, children: /* @__PURE__ */ o(f, { style: { width: "100%" }, ...m, value: c }) }) });
}, v = s(p);
export {
  v as default
};
//# sourceMappingURL=BironSelect.js.map
